module.exports = __webpack_public_path__ + "img/about-office-img-1.ffc3bca3.jpg";